import { useAtomValue } from 'jotai';
import { useProductNamesToOptimizeCountQuery } from '../../queries/__generated__/productNamesToOptimizeCount.generated';
import { currentContextAtom } from '../../state';
import { PRODUCT_NAME_TO_OPTIMIZE_WHERE } from './state';

interface ProductListCounts {
  allProductsCount: number;
  namesToOptimizeCount: number;
}

export default function useProductListCounts(): ProductListCounts {
  const { companyId } = useAtomValue(currentContextAtom);
  const { data } = useProductNamesToOptimizeCountQuery({
    variables: { companyId, toOptimizeWhere: PRODUCT_NAME_TO_OPTIMIZE_WHERE },
  });

  return {
    allProductsCount: data?.all_products.aggregate?.count ?? 0,
    namesToOptimizeCount: data?.to_optimize.aggregate?.count ?? 0,
  };
}
